import React from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import 'core/theme/datepicker.scss'
import { it } from 'date-fns/locale'
import i18n from 'stylewhere/i18n'

const DatePicker = (ReactDatePicker as any).default ?? ReactDatePicker
registerLocale('it', it)

interface CalendarPickerProps {
  startDate: Date | null
  endDate: Date | null
  onChange: (dates: [Date | null, Date | null]) => void
}

export const CalendarPicker: React.FC<CalendarPickerProps> = ({ startDate, endDate, onChange }) => {
  return (
    <DatePicker
      selected={startDate}
      onChange={onChange as any}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      inline
      locale={i18n.language}
    />
  )
}
